export default function capitalize( word ) {
    return word ? word.charAt(0).toUpperCase() + word.slice(1) : '';
}